module.exports = __webpack_public_path__ + "img/vegetable-cucumbers-190x100.93368bdb.jpg";